import gql from 'graphql-tag';

export default gql`
  mutation AddTestMeasurementMutation($request: HashimotoTestInputType!) {
    hashimoto {
      hashimotoTest(testData: $request) {
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;
